import COLORS from '../../../utils/constants/colors'

const streamFieldsStyles = {
  tvIcon: {
    '&&': {
      width: 25,
      height: 25,
    },
  },
  cancelIcon: {
    fill: COLORS.orange,
    cursor: 'pointer',
  },
  // YouTube mode: a single field split into a locked ingest-base chip and an editable key input.
  skRow: {
    display: 'flex',
    alignItems: 'stretch',
    background: '#F1F1F1',
    borderRadius: 4,
    overflow: 'hidden',
    border: '1px solid #E4E4E4',
  },
  skChip: {
    // sized to the short "YouTube" label; the key input takes the remaining width
    flex: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: 7,
    padding: '0 14px',
    background: '#E7E6E3',
    borderRight: '1px solid #DADAD6',
    userSelect: 'none',
  },
  skChipIcon: {
    '&&': { fontSize: 18, color: '#8A8A8A', flexShrink: 0 },
  },
  skChipText: {
    fontSize: 13,
    color: '#8A8A8A',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  skKeyInput: {
    flex: '1 1 0',
    minWidth: 0,
    border: 'none',
    background: 'transparent',
    padding: '13px 14px',
    fontSize: 14,
    color: '#3C3C3C',
    outline: 'none',
  },
  // Custom-server mode: a full rtmp:// URL input with a leading icon.
  skCustomRow: {
    position: 'relative',
    background: '#F1F1F1',
    borderRadius: 4,
    border: '1px solid #E4E4E4',
  },
  skCustomInput: {
    width: '100%',
    boxSizing: 'border-box',
    border: 'none',
    background: 'transparent',
    padding: '13px 44px',
    fontSize: 14,
    color: '#3C3C3C',
    outline: 'none',
  },
  skCustomIcon: {
    '&&': {
      position: 'absolute',
      left: 14,
      top: '50%',
      transform: 'translateY(-50%)',
      fontSize: 22,
      color: '#8A8A8A',
    },
  },
  // Coral text link that flips between YouTube mode and a custom RTMP server.
  serverToggle: {
    alignSelf: 'flex-start',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    color: COLORS.coral,
    fontSize: 12.5,
    fontWeight: 600,
    cursor: 'pointer',
    userSelect: 'none',
  },
  serverToggleIcon: {
    '&&': { fontSize: 16, color: COLORS.coral },
  },
  addButtonText: {
    '&&': {
      fontSize: '1rem',
      fontWeight: 400,
      color: COLORS.white,
    },
  },
  addStreamKeyLink: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    color: COLORS.coral,
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    userSelect: 'none',
  },
  addStreamKeyIcon: {
    '&&': {
      fontSize: 16,
    },
  },
  divider: {
    width: '70%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}

export default streamFieldsStyles
